import { observer } from "@legendapp/state/react";
import { useCurrentAttendanceSession } from "_api/hooks/attendances";
import { TxtSuspense } from "_components/suspense/parts";
import { EndSession } from "_pages/service/queue/components/top-bar/EndSession";
import { StartSession } from "_pages/service/queue/components/top-bar/StartSession";
import { ViewInfo } from "_pages/service/queue/components/top-bar/ViewInfo";
import { $currentAttendanceId, $viewingAttendanceId } from "_pages/service/queue/state";
import { UserDeskHub } from "_services/ws/user-desk-hub";
import { CurrentAttendanceSession } from "_types/responses/current-attendance-session";
import { HStack } from "_ui/Box";
import { plural } from "_utils/view";
import { useEffect } from "react";
import { Card } from "react-bootstrap";
import { When } from "react-if";
import { $onFilterChange } from "../table/Filters";
import { AttendanceInfo } from "./AttendanceInfo";

export const LeftSide = observer(({ attendanceSession, joined }: { joined: boolean, attendanceSession: CurrentAttendanceSession }) => {
    const attendanceId = $currentAttendanceId.$;
    const viewAttendanceId = $viewingAttendanceId.$;

    const onQueue = UserDeskHub.$allDesksInfo.$.length ?? 0;
    const filter = $onFilterChange.$;

    const onClick = () => {
        filter.resetFilters();
    }

    if (attendanceId) {
        return <AttendanceInfo />;
    }

    if (viewAttendanceId) {
        return <ViewInfo />;
    }

    if (UserDeskHub.$isConnected.get()) {

        const text = `${onQueue} ${plural(onQueue, 'pessoa', 'pessoas')} na fila`
        return <span>{text}</span>;
    }

    if (!!attendanceSession && !joined) {
        return <TxtSuspense />;
    }

    return <></>;
})

export const TopBar = observer(() => {

    const joined = UserDeskHub.$desksJoined.$;
    const { attendanceSession } = useCurrentAttendanceSession();

    useEffect(() => {
        if (attendanceSession) {
            if (!joined) {
                UserDeskHub.joinDesks();
            }
        }
    }, [attendanceSession]);

    return (
        <Card className='w-100 mb-1'>
            <Card.Body>
                <HStack between wrap alignCenter>
                    <HStack g={2}>
                        <LeftSide {...{ attendanceSession, joined }} />
                    </HStack>

                    <HStack g={2} end alignCenter>
                        <When condition={!!attendanceSession}>
                            <EndSession />
                        </When>
                        <When condition={!attendanceSession}>
                            <StartSession />
                        </When>
                    </HStack>
                </HStack>
            </Card.Body>
        </Card>
    );
})
